
/* no lo uso  */
<template>
  <div class="xcard">
    <div class="row">
      <div class="col-sm-6">
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> Buscar </div>
          <input type="text" v-model.trim="filtro" class="form-control" placeholder="Ingrese el documento o el nombre">
        </div>
        <p> <small>{{msg}}</small> </p>
      </div>
      <div class="col-sm-6"></div>
    </div>

    <p v-show="datos.length>0">Presione <a class="btn btn-sm btn-link" @click="verMas()">AQUI</a> para buscar las siguientes 5 coincidencias.</p>
    <div class="table-responsive">
      <table class="table table-condensed table-hover table-striped">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Estudiante</th>
            <th>Documento</th>
            <th>Telefono</th>
            <th>Email</th>
            <th>Usuario Moodle</th>
            <th>Clave Moodle</th>
            <th>Registro</th>
            <th>Usuario</th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in datos">
            <td> {{tam-ind}} </td>
            <td> {{e.nombre}} </td>
            <td> {{e.num_doc}} </td>
            <td> {{e.telefono1}} </td>
            <td> {{e.email}} </td>
            <td> {{e.usuario_moodle}} </td>
            <td> {{e.clave_moodle}} </td>
            <td> {{parseFecha(e.fecha_reg)}} </td>
            <td> {{e.user}} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
//import {parseJsonError} from '@/components/Utils.js'

export default {
  data(){
    return{
      isLoading: false,
      timeoutHnd: 0,
      filtro: null,
      msg:null,
      cursor: 10000000,
      tam: 0,
      datos:[],
    }
  },
  watch:{
    'filtro': function(){
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function () {
          vue.cursor = 10000000;
          if(vue.filtro.length>2) {
            vue.asyncFind( false );
          }else{
            vue.msg = "";
            vue.datos = [];
          }
          this.timeoutHnd = 0;
        }, 500);      
      }
  },
  methods:{
    parseLabel( option ){
      if( option == null ) return "";
      var seg = option.seg_apellido;
      if( seg == null ) seg = "";
      return option.nombres + " "+option.pri_apellido+" "+seg;
    },
    parseFecha( f ){
      if( f == null ) return "";
      var date = new Date( f );
      var d = date.getDate();
      var m = date.getMonth()+1;
      var min = date.getMinutes();
      if( d < 10 ) d = '0'+d
      if( m < 10 ) m = '0'+m
      if( min < 10 ) min = '0'+min

      return d+'/'+m+'/'+date.getFullYear()+' '+date.getHours()+':'+min;
    },
    verMas(){
      this.asyncFind( true );
    },
    async asyncFind ( withCursor) {
      var query = this.filtro;
      if( query.length <= 3 ) return;
      this.isLoading = true
      var vue = this;
      var isdocumento = /^\d+$/.test(query);
      this.msg = "Buscando por nombre...";

      var sql = gql`query{ getDocentesByName(nombres:"${query}",cursor:${this.cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} } }`;
      if( isdocumento ) {
        sql = gql`query{ getDocentesByDoc(num_doc:"${query}",cursor:${this.cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} } }`;
        this.msg = "Buscando por documento...";
      }
      // window.console.log( sql );

      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        if( !withCursor ) vue.datos = [];
        var datas = [];
        vue.isLoading = false;
        if( data.data == null ) data.data = [];

        for (var propName in data.data) { 
          if( propName == "getDocentesByName" || propName == "getDocentesByDoc" ){
            // window.console.log( "Haber esto",data.data[propName] )
            data.data[propName].forEach( function(e){
              e.nombre = vue.parseLabel( e );
              if( e.usuario ) e.user = vue.parseLabel( e.usuario.datos_personales );
              datas.push( e );
              vue.cursor = e.id;
            });
          }
        }

        if( withCursor ) vue.datos = datas.concat( vue.datos );
        else vue.datos = datas;
        vue.tam = vue.datos.length;
        vue.msg = "";
        // window.console.log( withCursor,vue.datos )

      }).catch((error) => {
        window.console.error(error)
        vue.isLoading = false;
        vue.msg = "No se pudo buscar, ingrese un nombre o documento con formato valido.";
        //this.$notify( parseJsonError( error,'getDocentesByName' ) )
      })
    },
  }
}
</script>